import { Field } from "formik";
import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";
import { FormCheck, FormCheckList } from "../../form/FormCheck";
import ValidatedField from "../../form/ValidatedField";

export default function RevisorsOevrigeOplysninger(
  props: RevisorsSectionProps,
) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_oevrige_oplysninger } = texts;
  const { values, touched, errors } = formikProps;
  return (
    <AccordionItem value="oevrige">
      <AccordionHeader
        sectionStarted={
          values.revisors_oevrige_oplysninger_kundeforhold_accepteret_dato !==
            undefined ||
          values.revisors_oevrige_oplysninger_revisors_navn !== undefined ||
          values.revisors_oevrige_oplysninger_revisor_type !== undefined ||
          values.revisors_oevrige_oplysninger_revisor_type !== undefined ||
          values.revisors_oevrige_oplysninger_firmanavn !== undefined ||
          values.revisors_oevrige_oplysninger_cvrnr !== undefined ||
          values.revisors_oevrige_oplysninger_adr_vej_husnr !== undefined ||
          values.revisors_oevrige_oplysninger_adr_postnr_by !== undefined
        }
        sectionComplete={
          isCompleteHelpers.revisors_oevrige_oplysninger_complete
        }
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_16_ref);
        }}
      >
        {revisors_oevrige_oplysninger.title}
      </AccordionHeader>
      <AccordionBody>
        <div className="c-form-row row g-0 pt-2 pb-4 align-items-center border-top-0">
          <div className="col-9">
            <label
              className="form-label"
              htmlFor={
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_kundeforhold_accepteret_dato.id
              }
            >
              {
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_kundeforhold_accepteret_dato
                  .label
              }
            </label>
          </div>
          <div className="col-3">
            <ValidatedField
              locked={locked}
              error={
                errors.revisors_oevrige_oplysninger_kundeforhold_accepteret_dato
              }
              touched={
                touched.revisors_oevrige_oplysninger_kundeforhold_accepteret_dato
              }
              autoComplete="off"
              type="date"
              name={
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_kundeforhold_accepteret_dato.id
              }
              id={
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_kundeforhold_accepteret_dato.id
              }
            />
          </div>
        </div>
        <fieldset disabled={locked} className="c-form-row py-4">
          <legend className="h5 fw-normal mb-4 lh-base">
            {revisors_oevrige_oplysninger.checkboxes_description}
          </legend>
          <FormCheckList className="px-3">
            <FormCheck
              id={
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_revision_af_aarsregnskab
                  .id
              }
            >
              {
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_revision_af_aarsregnskab
                  .label
              }
            </FormCheck>
            <FormCheck
              id={
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_udvidet_gennemgang_af_aarsregnskab
                  .id
              }
            >
              {
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_udvidet_gennemgang_af_aarsregnskab
                  .label
              }
            </FormCheck>
            <FormCheck
              id={
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_review_af_aarsregnskab
                  .id
              }
            >
              {
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_review_af_aarsregnskab
                  .label
              }
            </FormCheck>
            <FormCheck
              id={
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_assistance_med_regnskabsopslilling_af_aarsregnskab
                  .id
              }
            >
              {
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_assistance_med_regnskabsopslilling_af_aarsregnskab
                  .label
              }
            </FormCheck>
            <FormCheck
              id={
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_bogfoering
                  .id
              }
            >
              {
                revisors_oevrige_oplysninger
                  .revisors_oevrige_oplysninger_arbejsdomraade_checkbox_bogfoering
                  .label
              }
            </FormCheck>
          </FormCheckList>
        </fieldset>
        <hr />
        <fieldset className="py-4" disabled={locked}>
          <div className="row gy-4 gx-5">
            <div className="col-6">
              <label
                className="form-label"
                htmlFor={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_revisors_navn.id
                }
              >
                {
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_revisors_navn.label
                }
              </label>
              <ValidatedField
                touched={touched.revisors_oevrige_oplysninger_revisors_navn}
                error={errors.revisors_oevrige_oplysninger_revisors_navn}
                autoComplete="off"
                type="text"
                placeholder="Navn"
                id={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_revisors_navn.id
                }
                name={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_revisors_navn.id
                }
                wrapper
              />
            </div>
            <div className="col-6">
              <h5 className="form-label">
                {
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_revisor_type.label
                }
              </h5>
              <div className="d-flex gap-3">
                <div className="form-check">
                  <Field
                    type="radio"
                    className="form-check-input"
                    name={
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type.id
                    }
                    id={
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type
                        .revisors_oevrige_oplysninger_revisor_type_option_registreret_revisor
                        .id
                    }
                    value={
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type
                        .revisors_oevrige_oplysninger_revisor_type_option_registreret_revisor
                        .id
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type
                        .revisors_oevrige_oplysninger_revisor_type_option_registreret_revisor
                        .id
                    }
                  >
                    {
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type
                        .revisors_oevrige_oplysninger_revisor_type_option_registreret_revisor
                        .label
                    }
                  </label>
                </div>
                <div className="form-check">
                  <Field
                    type="radio"
                    className="form-check-input"
                    name={
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type.id
                    }
                    id={
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type
                        .revisors_oevrige_oplysninger_revisor_type_option_statsautoriseret_revisor
                        .id
                    }
                    value={
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type
                        .revisors_oevrige_oplysninger_revisor_type_option_statsautoriseret_revisor
                        .id
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type
                        .revisors_oevrige_oplysninger_revisor_type_option_statsautoriseret_revisor
                        .id
                    }
                  >
                    {
                      revisors_oevrige_oplysninger
                        .revisors_oevrige_oplysninger_revisor_type
                        .revisors_oevrige_oplysninger_revisor_type_option_statsautoriseret_revisor
                        .label
                    }
                  </label>
                </div>
              </div>
            </div>
            <div className="col-6">
              <label
                className="form-label"
                htmlFor={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_firmanavn.id
                }
              >
                {
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_firmanavn.label
                }
              </label>
              <ValidatedField
                touched={touched.revisors_oevrige_oplysninger_firmanavn}
                error={errors.revisors_oevrige_oplysninger_firmanavn}
                autoComplete="off"
                type="text"
                placeholder="Firma"
                id={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_firmanavn.id
                }
                name={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_firmanavn.id
                }
                wrapper
              />
            </div>
            <div className="col-6">
              <label
                className="form-label"
                htmlFor={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_cvrnr.id
                }
              >
                {
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_cvrnr.label
                }
              </label>
              <ValidatedField
                error={errors.revisors_oevrige_oplysninger_cvrnr}
                touched={touched.revisors_oevrige_oplysninger_cvrnr}
                autoComplete="off"
                type="text"
                placeholder="CVR-nummer"
                id={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_cvrnr.id
                }
                name={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_cvrnr.id
                }
                wrapper
              />
            </div>
            <div className="col-6">
              <label
                className="form-label"
                htmlFor={
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_adr_vej_husnr.id
                }
              >
                {
                  revisors_oevrige_oplysninger
                    .revisors_oevrige_oplysninger_adr_vej_husnr.label
                }
              </label>
              <div className="vstack gap-3">
                <ValidatedField
                  touched={touched.revisors_oevrige_oplysninger_adr_vej_husnr}
                  error={errors.revisors_oevrige_oplysninger_adr_vej_husnr}
                  autoComplete="off"
                  type="text"
                  placeholder="Vej, husnummer"
                  id={
                    revisors_oevrige_oplysninger
                      .revisors_oevrige_oplysninger_adr_vej_husnr.id
                  }
                  name={
                    revisors_oevrige_oplysninger
                      .revisors_oevrige_oplysninger_adr_vej_husnr.id
                  }
                  wrapper
                />
                <ValidatedField
                  touched={touched.revisors_oevrige_oplysninger_adr_postnr_by}
                  error={errors.revisors_oevrige_oplysninger_adr_postnr_by}
                  autoComplete="off"
                  type="text"
                  className="form-control"
                  placeholder="Postnummer og by"
                  id={
                    revisors_oevrige_oplysninger
                      .revisors_oevrige_oplysninger_adr_postnr_by.id
                  }
                  name={
                    revisors_oevrige_oplysninger
                      .revisors_oevrige_oplysninger_adr_postnr_by.id
                  }
                  wrapper
                />
              </div>
            </div>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
